import { ColumnDef } from '@tanstack/react-table';
import { Pencil } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { AddOn } from 'src/trpc';
import { MoneyFromCents } from '@libs/services/money';

// Extend the AddOn type to include the onEdit function
interface AddOnWithActions extends AddOn {
  onEdit: (addOn: AddOn) => void;
}

export const addOnColumns: ColumnDef<AddOnWithActions>[] = [
  {
    accessorKey: 'title',
    header: 'Title',
  },
  {
    accessorKey: 'description',
    header: 'Description',
  },
  {
    accessorKey: 'customerVisible',
    header: 'Customer Visible',
    cell: ({ row }) => (
      <div className="w-fit">
        <Badge variant={row.original.customerVisible ? 'success' : 'secondary'}>
          {row.original.customerVisible ? 'Yes' : 'No'}
        </Badge>
      </div>
    ),
  },
  {
    accessorKey: 'priceInCents',
    header: 'Price',
    cell: ({ row }) => MoneyFromCents(row.original.priceInCents).toFormat(),
  },
  {
    accessorKey: 'archived',
    header: 'Archived',
    cell: ({ row }) => (row.original.archived ? 'Yes' : 'No'),
  },
  {
    id: 'actions',
    header: 'Edit',
    cell: ({ row }) => (
      <Button variant="ghost" onClick={() => row.original.onEdit(row.original)}>
        <Pencil className="h-4 w-4" />
      </Button>
    ),
  },
];
